import React from 'react';
import { formatPriceDollars } from '../../../Helpers';
import { Size, Quantity } from '../../../Icons';
import { presentmentPrice } from '../../../multi_currency';

const imgSrc = 'https://cdn.shopify.com/s/files/1/0272/0320/7246/products/tights_637ecfb1-b8fd-44c9-8fcb-c5e4581232d9.jpg?v=1572215730'

export const OptionQuantity = (props) => {
	return (
		<div className={`BoxBuilder_Option--Quantity ${props.selected ? 'selected' : ''}`} onClick={props.handleSelection}>

			<span className="BoxBuilder_Option--Quantity-savings large">{props.discountPercent > 0 && `save ${props.discountPercent}%`}</span>
			<div>
				<span>{Quantity(props.quantity)}</span>
			</div>
			<p className="BoxBuilder_Option--Quantity-description">{props.description}
				{props.discountPercent > 0 &&
					<strong className="BoxBuilder_Option--Quantity-savings small">{`save ${props.discountPercent}%`}</strong>
				}
			</p>
		</div>
	)
}

export const OptionType = (props) => {
	return (
		<div className="BoxBuilder_Option--Type">
			<div>
				<div className="BoxBuilder_Option--Type-image">
					<img src={props.imgSrc ? props.imgSrc.src : imgSrc} />
				</div>
				<div className={`BoxBuilder_Option--Type-overlay ${props.quantity > 0 ? 'selected' : ''}`}>
					<span className="BoxBuilder_Option--Type-minus BoxBuilder_Option--Type-quantity-select large" onClick={() => props.handleTypeSelection(props.product_id, -1)}>
						<span className="minus"></span>
					</span>
					<span>{props.quantity > 0 ? props.quantity : ''}</span>
					<span className="BoxBuilder_Option--Type-plus BoxBuilder_Option--Type-quantity-select large" onClick={() => props.handleTypeSelection(props.product_id, 1)}>
						<span className="plus"></span>
					</span>
				</div>
			</div>
			<div>
				<h3>{props.title}</h3>
				<span className="BoxBuilder_Option--Type-price">{presentmentPrice(props.setCurrency, props.presentmentPrices)}</span>
			</div>
			<div className="BoxBuilder_Option--Type-quantity-select-group small">
				<span className="BoxBuilder_Option--Type-plus BoxBuilder_Option--Type-quantity-select" onClick={() => props.handleTypeSelection(props.product_id, 1)}>
					<span className="plus"></span>
				</span>
				<span className="BoxBuilder_Option--Type-minus BoxBuilder_Option--Type-quantity-select" onClick={() => props.handleTypeSelection(props.product_id, -1)}>
					<span className="minus"></span>
				</span>
			</div>
		</div>
	)
}

export const OptionSize = (props) => {
	return (
		<div className={`BoxBuilder_Option--Size ${props.selected ? 'selected' : ''}`} onClick={props.handleSizeSelection}>
			<span>{Size(props.size)}</span>
		</div>
	)
}